module.exports = __webpack_public_path__ + "img/tip.bb9ada1f.gif";